<template>
    <div>
        <Panel module="Financeiro" title="Conciliação Bancária" :showFilter="false" :showSearch="false"
            :showButtons="true">
            <div slot="content-buttons">
                <Button _key="btnOpenImportExtrato" type="primary" title="Importar Extrato"
                    classIcon="fa-solid fa-file-import" size="small" :clicked="openImportExtrato" />
            </div>
            <div slot="content-main">
                <div class="main-reconciliation">
                    <BankReconciliationMain />
                </div>
            </div>
        </Panel>
    </div>
</template>

<script>

import Panel from "@/ui/layout/Panel";
import Button from "@/ui/forms/Button";
import BankReconciliationMain from "@/modules/finance/components/bankReconciliation/BankReconciliationMain.vue";

import { mapMutations } from "vuex";

export default {
    name: "BankReconciliationView",
    components: {
        Panel, Button, BankReconciliationMain
    },
    mounted() {
        this.removeLoading(["panel"]);
    },
    methods: {
        ...mapMutations("generic", ["removeLoading", "openModal"]),
        openImportExtrato() {
            this.openModal("importExtrato");
            this.removeLoading(["btnOpenImportExtrato"]);
        },
    },
};
</script>

<style scoped>
.main-reconciliation {
    margin-top: 40px;
}
</style>